import {Box} from '@mui/material';
import {ExamModule, ModuleTopic} from '@cp/model';
import ModuleViewGenerateButton from './ModuleViewGenerateButton';

export interface ModuleViewGenerateProps {
  examModule: ExamModule;
  topic: ModuleTopic;
}

export default function ModuleViewGenerate({examModule, topic}: ModuleViewGenerateProps) {
  return (
    <Box sx={{display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center'}}>
      {/* Individual difficulty buttons */}
      {[1, 2, 3, 4, 5].map((difficulty) => (
        <ModuleViewGenerateButton key={difficulty} examModule={examModule} topic={topic} difficulty={difficulty} />
      ))}

      {/* All difficulties button */}
      <ModuleViewGenerateButton examModule={examModule} topic={topic} difficulty={undefined} label="All" />
    </Box>
  );
}
